import React from "react";
import PropTypes from "prop-types";
import NavigationSelect from "./NavigationSelect";
import NavigationPageButton from "./NavigationPageButton";
import { PagingIcon } from "./PagingIcon";

export default class Navigation extends React.Component {
    constructor() {
        super();

        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.handleSortByChange = this.handleSortByChange.bind(this);
    }

    componentDidUpdate(){
        let pageAt =this.props.currentPage;
        let currentPageTitle = document.title;
        const hasPageReg = new RegExp("(Page)\\s{1,}[0-9]{1,}", "gi");
        const movePageReg = new RegExp("\\s\\|(\\sPage)\\s{1,}[0-9]{1,}", "gi");
        let hasPage = hasPageReg.test(currentPageTitle);
        const hasPipeReg = new RegExp("\\s\\|\\s");
        let newPageTitle = currentPageTitle;

        if (pageAt > 1) {
            if (hasPage) {
                newPageTitle = currentPageTitle.replace(
                    hasPageReg,
                    `$1 ${pageAt}`
                );
            } else {
                const hasPipeInTitle = hasPipeReg.test(currentPageTitle);

                newPageTitle = hasPipeInTitle
                    ? currentPageTitle.replace(hasPipeReg, ` | Page ${pageAt} | `)
                    : `${currentPageTitle} | Page ${pageAt} `;
            }
        }else {
            if (hasPage) {
                newPageTitle = currentPageTitle.replace(movePageReg, "");
            }
        }
        document.title = newPageTitle;
    }

    handlePageChange(pageTarget, href) {
        if (this.props.pushHistoryOnChange) {
            history.pushState({ page: pageTarget }, `page ${pageTarget}`, href);
        }

        this.props.goTo(pageTarget);
    }

    handlePageSizeChange(newPageSize) {
        this.props.changePageSize(newPageSize);
    }

    handleSortByChange(newSortBy) {
        this.props.changeSortBy(newSortBy);
    }

    render() {
        let min =
            this.props.currentPage == 1 ||
            this.props.maxPage == 1 ||
            this.props.currentPage - 2 < 1
                ? 1
                : this.props.currentPage != this.props.maxPage &&
                  this.props.currentPage - 2 >= 1
                    ? this.props.currentPage - 1
                    : this.props.currentPage - 2;

        let max =
            this.props.currentPage >= 1 &&
            this.props.currentPage + 2 < 4 &&
            this.props.currentPage + 2 < this.props.maxPage
                ? 4
                : this.props.currentPage + 2 < this.props.maxPage
                    ? this.props.currentPage + 2
                    : this.props.maxPage + 1;

        let pageNumbers = [];

        for (let i = min; i < max; i++) {
            pageNumbers.push(
                <NavigationPageButton
                    key={i}
                    active={i == this.props.currentPage ? true : false}
                    currentPage={i}
                    pageSize={this.props.pageSize}
                    currentPageUrlPrefix={this.props.currentPageUrlPrefix}
                    pageSizeUrlPrefix={this.props.pageSizeUrlPrefix}
                    goTo={this.handlePageChange}
                >
                    {i}
                </NavigationPageButton>
            );
        }

        return (
            <div className="pagination">
                {this.props.showView && (
                    <PagingIcon
                        changeView={this.props.changeView}
                        view={this.props.view}
                    />
                )}
                {this.props.showActions && this.props.actionComponent}

                <section
                    id="pages"
                    className={`${!this.props.showView && "paging-full"}`}
                >
                    {this.props.currentPage > 2 && (
                        <NavigationPageButton
                            key={"first"}
                            currentPage={1}
                            pageSize={this.props.pageSize}
                            currentPageUrlPrefix={
                                this.props.currentPageUrlPrefix
                            }
                            pageSizeUrlPrefix={this.props.pageSizeUrlPrefix}
                            goTo={this.handlePageChange}
                        >
                            &lt;&lt;
                        </NavigationPageButton>
                    )}
                    {this.props.currentPage > 1 && (
                        <NavigationPageButton
                            key={"prev"}
                            previous
                            currentPage={this.props.currentPage}
                            pageSize={this.props.pageSize}
                            currentPageUrlPrefix={
                                this.props.currentPageUrlPrefix
                            }
                            pageSizeUrlPrefix={this.props.pageSizeUrlPrefix}
                            goTo={this.handlePageChange}
                        >
                            &lt;
                        </NavigationPageButton>
                    )}
                    {pageNumbers}
                    {this.props.currentPage < this.props.maxPage &&
                        this.props.currentPage != this.props.maxPage && (
                        <NavigationPageButton
                            key="next"
                            next
                            currentPage={this.props.currentPage}
                            pageSize={this.props.pageSize}
                            currentPageUrlPrefix={
                                this.props.currentPageUrlPrefix
                            }
                            pageSizeUrlPrefix={this.props.pageSizeUrlPrefix}
                            goTo={this.handlePageChange}
                        >
                            &gt;
                        </NavigationPageButton>
                    )}
                    {this.props.currentPage < this.props.maxPage - 1 && (
                        <NavigationPageButton
                            key={"last"}
                            currentPage={this.props.maxPage}
                            pageSize={this.props.pageSize}
                            currentPageUrlPrefix={
                                this.props.currentPageUrlPrefix
                            }
                            pageSizeUrlPrefix={this.props.pageSizeUrlPrefix}
                            goTo={this.handlePageChange}
                        >
                            &gt;&gt;
                        </NavigationPageButton>
                    )}
                </section>
                <div className="show-per-page">
                    <span>Show</span>
                    <NavigationSelect
                        key="show-per-page"
                        selectedOption={this.props.pageSize}
                        options={this.props.pageSizeOptions}
                        changeSelectedOption={this.handlePageSizeChange}
                    />
                    <span>Per Page</span>
                </div>
                {this.props.sortByOptions.length > 0 && (
                    <div className="sort-by">
                        <span>Sort By</span>
                        <NavigationSelect
                            key="sort-by"
                            selectedOption={this.props.sortBy}
                            options={this.props.sortByOptions}
                            changeSelectedOption={this.handleSortByChange}
                        />
                    </div>
                )}
            </div>
        );
    }
}
Navigation.defaultProps = {
    currentPage: 1,
    pageSize: 16,
    pageSizeOptions: ["16", "32", "64", "96"],
    sortByOptions: [],
    maxPage: 1,
    view: "grid",
    showView: true,
    showActions: false,
    pushHistoryOnChange: true,
    currentPageUrlPrefix: "?currentPage=",
    pageSizeUrlPrefix: "&pageSize="
};

Navigation.propTypes = {
    currentPage: PropTypes.number,
    maxPage: PropTypes.number,
    pageSize: PropTypes.number,
    pageSizeOptions: PropTypes.array,
    sortBy: PropTypes.string,
    sortByOptions: PropTypes.array,
    goTo: PropTypes.func,
    view: PropTypes.string,
    showView: PropTypes.bool,
    showActions: PropTypes.bool,
    changeSortBy: PropTypes.func,
    changePageSize: PropTypes.func,
    changeView: PropTypes.func,
    actionComponent: PropTypes.element,
    pushHistoryOnChange: PropTypes.bool,
    currentPageUrlPrefix: PropTypes.string,
    pageSizeUrlPrefix: PropTypes.string
};
